export default function Header({ children }: { children: React.ReactNode}) {
  return (
    <div className="card-header">
      {children}
    </div>
  )
}